import styles from './gallery-unavailable-page.module.css';

export const GalleryUnavailablePage = () => (
  <div className={styles.container}>
    <p>This gallery is temporarily unavailable.</p>
    <p>Please check back later, or contact the photographer directly.</p>
  </div>
);
